
import { defineComponent, PropType } from 'vue'
import { iPerspective, iScorecardCriterion, iScorecardTarget, iKpi } from '../Scorecards'
import { getSelectedCriteriaTooltip, getDefaultCriterion, getSelectedCriteria } from '../ScorecardsHelpers'
import MultiSelect from 'primevue/multiselect'
import SelectButton from 'primevue/selectbutton'
import descriptor from './ScorecardsTableDescriptor.json'
import ScorecardsTargetItem from './ScorecardsTargetItem.vue'
import ScorecardsTableHint from './ScorecardsTableHint.vue'

const crypto = require('crypto')

export default defineComponent({
    name: 'scorecards-perspective-item',
    components: { MultiSelect, SelectButton, ScorecardsTargetItem, ScorecardsTableHint },
    props: { propPerspective: { type: Object as PropType<iPerspective> }, criterias: { type: Array as PropType<iScorecardCriterion[]>, required: true }, kpis: { type: Array as PropType<iKpi[]>, required: true } },
    emits: ['deletePerspective', 'openKpiDialog', 'touched'],
    data() {
        return {
            descriptor,
            perspective: null as iPerspective | null,
            expanded: false,
            selectedCriteria: 'M',
            getSelectedCriteriaTooltip
        }
    },
    watch: {
        propPerspective() {
            this.loadPerspective()
        }
    },
    async created() {
        this.loadPerspective()
    },
    methods: {
        loadPerspective() {
            this.perspective = this.propPerspective as iPerspective
            if (this.perspective.name === 'New Perspective') this.expanded = true
            this.selectedCriteria = getSelectedCriteria(this.perspective.criterion?.valueCd)
        },
        addTarget() {
            if (this.perspective) {
                this.perspective.targets.push({ id:crypto.randomBytes(16).toString('hex'), name: 'New Target', status: 'GRAY', criterion: getDefaultCriterion(this.criterias), options: { criterionPriority: [] }, kpis: [], groupedKpis: [], new: true })
                this.$emit('touched')
                this.expanded = true
                this.perspective.updated = true
            }
        },
        onCriteriaChange() {
            if (!this.perspective) return

            for (let i = 0; i < this.criterias.length; i++) {
                if ((this.selectedCriteria === 'M' && this.criterias[i].valueCd === 'MAJORITY') || (this.selectedCriteria === 'MP' && this.criterias[i].valueCd === 'MAJORITY_WITH_PRIORITY') || (this.selectedCriteria === 'P' && this.criterias[i].valueCd === 'PRIORITY')) {
                    this.perspective.criterion = this.criterias[i]
                    this.$emit('touched')
                    this.perspective.updated = true
                    break
                }
            }

            this.perspective.options.criterionPriority = []
        },
        deletePerspectiveConfirm() {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteConfirmTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.$emit('deletePerspective', this.perspective)
            })
        },
        deleteTarget(target: iScorecardTarget) {
            console.log('TARGET: ', target)
            if (!this.perspective) return
            const index = this.perspective.targets.findIndex((tempTarget: iScorecardTarget) => tempTarget.id === target.id)
            if (index !== -1) {
                this.perspective.targets.splice(index, 1)
                if (this.perspective.criterion.valueCd !== 'MAJORITY') {
                    const index = this.perspective.options.criterionPriority.findIndex((criteria: string) => criteria === target.name)
                    if (index !== -1) this.perspective.options.criterionPriority.splice(index, 1)
                }
                this.$emit('touched')
                this.perspective.updated = true
            }
        },
        onTargetTouched(updatePerspective: boolean) {
            this.$emit('touched')
            if (this.perspective && updatePerspective) this.perspective.updated = true
        },
        onCriterionPriortyChanged() {
            this.$emit('touched', true)
            if (this.perspective) this.perspective.updated = true
        }
    }
})
